import { render, staticRenderFns } from "./taskBlock.vue?vue&type=template&id=25a0fb89&"
import script from "./taskBlock.vue?vue&type=script&lang=js&"
export * from "./taskBlock.vue?vue&type=script&lang=js&"
import style0 from "./taskBlock.vue?vue&type=style&index=0&id=25a0fb89&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports